exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "div.rankview table.ranker{padding-bottom:1.5rem!important}div.rankview table.ranker td:last-child,div.rankview table.ranker th:last-child{border-right:1px solid #a9a9a9}div.rankview div.board{width:100%;height:100%;padding:0;overflow-x:auto}div.rankview div.board>table{position:absolute}div.rankview div.board>table td,div.rankview div.board>table th{width:60px;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-1510bbeb","scoped":false,"hasInlineConfig":false}!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RankView.vue
// module id = 529
// module chunks = 0